<template>
  <div class="mainContainer" v-loading="importLoading">
    <div class="nav">
      <div class="navContainer" style="width: 210px">
        <p>供应商：</p>
        <el-input
          v-model="queryParams.supplierName"
          size="mini"
          style="width: 150px"
          placeholder="请输入委托商名称" />
      </div>
      <div class="navContainer" style="width: 210px">
        <p>起始港：</p>
        <el-input
          v-model="queryParams.departurePort"
          size="mini"
          style="width: 150px"
          placeholder="请输入起始港" />
      </div>
      <div class="navContainer" style="width: 210px">
        <p>交车港：</p>
        <el-input
          v-model="queryParams.arrivePort"
          size="mini"
          style="width: 150px"
          placeholder="请输入交车港" />
      </div>
      <div class="navContainer" style="width: 230px">
        <p>适配车型：</p>
        <el-input
          v-model="queryParams.customerCarName"
          size="mini"
          style="width: 150px"
          placeholder="请输入适配车型" />
      </div>
      <div class="navContainer">
        <p>状态：</p>
        <el-select
          v-model="queryParams.status"
          filterable
          size="mini"
          style="width: 150px"
          placeholder="请选择状态">
          <el-option
            v-for="item in stateOption"
            :key="item.label"
            :label="item.label"
            :value="item.value" />
        </el-select>
      </div>
      <div class="navContainer" style="width: 230px">
        <p>录入人员：</p>
        <el-input v-model="queryParams.createByName" size="mini" style="width: 150px" placeholder="请输入录入人员" />
      </div>
      <div class="navBtn">
        <el-button size="small" class="searchBtn" @click="searchBtn">查询</el-button>
        <el-button size="small" class="resetBtn" @click="resetBtn">重置</el-button>
        <el-button size="small" type="primary" @click="addBtn">新增</el-button>
        <el-button size="small" type="primary" @click="batchEnable">启用</el-button>
        <el-button size="small" type="danger" @click="onClickDeletes">批量删除</el-button>
        <el-button size="small" class="resetBtn" @click="onClickStops">批量停用</el-button>
      </div>
    </div>
    <!-- <el-row>
      <el-col :span='24' style='text-align: end;font-size: 14px!important;' class='exportButton'>
        <span @click='exportData'>导出数据</span>
      </el-col>
    </el-row> -->
    <div class="content">
      <div class="tableContainer">
        <div style="display: flex; justify-content: flex-end">
          <span
            style="
              cursor: pointer;
              font-size: 16px;
              margin-right: 10px;
              color: rgba(51, 136, 255, 1);
              display: flex;
              align-items: center;
            "
            class="el-icon-download el-icon--right table-btn"
            @click="download"
            >模板下载</span
          >
          <span style="cursor: pointer">
            <el-upload
              ref="upload"
              class="upload-demo"
              style="color: rgba(51, 136, 255, 1)"
              :action="uploadUrl"
              :auto-upload="true"
              :show-file-list="false"
              :data="uploadData"
              :on-success="planOnSuccess"
              :before-upload="beforeUpload">
              <i class="el-icon-upload el-icon--right">批量导入</i>
            </el-upload>
          </span>
          <span
            @click="exportData"
            style="
              cursor: pointer;
              font-size: 16px;
              color: rgba(51, 136, 255, 1);
              line-height: 21px;
              margin-left: 10px;
            "
            class="el-icon--right table-btn"
            >导出数据</span
          >
        </div>
        <el-table
          ref="tableRef"
          v-loading="tableLoad"
          :data="TableData"
          style="width: 100%"
          border
          :header-cell-style="{
            color: '#3B3B3B',
            'font-size': '13px',
            height: '48px',
            background: '#E8E8E8',
          }"
          :cell-style="{ color: '#7F7F7F', 'font-size': '13px', height: '52px' }"
          @selection-change="selectionChange"
          :row-key="getRowKey"
          :row-style="rowStyle">
          <el-table-column
            type="selection"
            align="center"
            width="55"
            :reserve-selection="true"></el-table-column>
          <el-table-column label="序号" align="center" width="50px" type="index" />
          <el-table-column
            prop="supplierName"
            label="供应商"
            align="center"
            width="150"
            show-overflow-tooltip />
          <el-table-column
            property="contractCode"
            label="合同编号"
            min-width="140"
            align="center"
            show-overflow-tooltip />
          <el-table-column
            property="contractName"
            label="合同名称"
            min-width="150"
            align="center"
            show-overflow-tooltip />
          <el-table-column
            prop="departurePort"
            label="起始港"
            align="center"
            max-width="120"
            show-overflow-tooltip />
          <el-table-column
            prop="arrivePort"
            label="交车港"
            align="center"
            max-width="120"
            show-overflow-tooltip />
          <el-table-column
            prop="customerCarName"
            label="适配车型"
            align="center"
            max-width="120"
            show-overflow-tooltip />
          <el-table-column prop="isLoading" label="装车费" align="center">
            <div slot-scope="scope">{{ scope.row.isLoading ? '拦截' : '不拦截' }}</div>
          </el-table-column>
          <el-table-column prop="isUnload" label="卸车费" align="center">
            <div slot-scope="scope">{{ scope.row.isUnload ? '拦截' : '不拦截' }}</div>
          </el-table-column>
          <el-table-column prop="isExchange" label="过驳费" align="center">
            <div slot-scope="scope">{{ scope.row.isExchange ? '拦截' : '不拦截' }}</div>
          </el-table-column>
          <el-table-column prop="isExchangeShip" label="转船费" align="center">
            <div slot-scope="scope">
              {{
                scope.row.isExchangeShip === 1
                  ? '全部拦截'
                  : scope.row.isExchangeShip === 2
                  ? '拦截一半'
                  : '全部不拦截'
              }}
            </div>
          </el-table-column>
          <el-table-column
            prop="createTime"
            label="创建时间"
            show-overflow-tooltip
            width="150"
            align="center">
            <template slot-scope="scope">{{ scope.row.createTime | getCreatTime }}</template>
          </el-table-column>
          <el-table-column
            prop="createByName"
            label="录入人员"
            show-overflow-tooltip
            width="150"
            align="center" />
          <el-table-column prop="startDate" label="有效起始" align="center" width="140" />
          <el-table-column prop="endDate" label="结束时间" align="center" width="140" />
          <el-table-column label="状态" align="center">
            <div slot-scope="scope">{{ getState(scope.row.status) }}</div>
          </el-table-column>
          <el-table-column label="操作" width="360" align="center">
            <template slot-scope="scope">
              <div style="align-items: center">
                <el-button
                  size="mini"
                  class="searchBtn"
                  type="primary"
                  @click="detailClick(scope.row.id)"
                  >详情
                </el-button>
                <el-button
                  v-if="scope.row.status === 0 || scope.row.status === 1"
                  size="mini"
                  class="yellow-bg"
                  type="primary"
                  @click="changeClick(scope.row.id,scope.row.status)"
                  >{{scope.row.status === 0  ? '修改' : '修改车型'}}
                </el-button>
                <el-button
                  v-if="scope.row.status == 0"
                  size="mini"
                  type="primary"
                  @click="enableClick(scope.row)"
                  >启用
                </el-button>
                <el-button
                  v-if="scope.row.status == 1"
                  size="mini"
                  type="danger"
                  @click="disableClick(scope.row)"
                  >停用
                </el-button>
                <el-button size="mini" type="info" @click="deleteClick(scope.row.id)"
                  >删除
                </el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="paginationContainer">
        <span>共{{ total }}条</span>
        <el-pagination
          background
          :page-sizes="[10, 20, 30, 40]"
          layout="sizes,prev, pager, next,jumper"
          :total="total"
          @size-change="contractSizeChange"
          @current-change="contractCurrentChange"
          @prev-click="contractCurrentChange"
          @next-click="contractCurrentChange" />
      </div>
    </div>
    <el-dialog title="详情" :visible.sync="detailDialogVisible" width="600px" center top="10vh">
      <div class="detail">
        <div class="baseInfo">
          <div class="baseInfoTitle">
            <div class="line" />
            <span>基础信息</span>
          </div>
          <div class="baseInfoContent">
            <div class="baseInfoContentItem">
              <span class="span1">供应商：</span>
              <span>{{ detailData.supplierName }}</span>
            </div>
            <div class="baseInfoContentItem">
              <span class="span1">合同名称：</span>
              <span>{{ detailData.contractName }}</span>
            </div>
            <div class="baseInfoContentItem">
              <span class="span1">合同编号：</span>
              <span>{{ detailData.contractCode }}</span>
            </div>
            <div class="baseInfoContentItem">
              <span class="span1">线路：</span>
              <span>{{ detailData.lineName }}</span>
            </div>
            <div class="baseInfoContentItem">
              <span class="span1">适配车型：</span>
              <span>{{ detailData.customerCarName }}</span>
            </div>
            <div class="baseInfoContentItem specialItem">
              <div class="specialOne">
                <span class="span1">起始港：</span>
                <span>{{ detailData.departurePort }}</span>
              </div>
              <div class="specialOne">
                <span class="span1">交车港：</span>
                <span>{{ detailData.arrivePort }}</span>
              </div>
            </div>
            <div class="baseInfoContentItem specialItem">
              <div class="specialOne">
                <span class="span1">有效起始：</span>
                <span>{{ detailData.startDate }}</span>
              </div>
              <div class="specialOne">
                <span class="span1">结束日期：</span>
                <span>{{ detailData.endDate }}</span>
              </div>
            </div>
            <div class="baseInfoContentItem specialItem">
              <div class="specialOne">
                <span class="span1">装车费：</span>
                <span>{{ detailData.isLoading == 1 ? '拦截' : '不拦截' }}</span>
              </div>
              <div class="specialOne">
                <span class="span1">卸车费：</span>
                <span>{{ detailData.isUnload == 1 ? '拦截' : '不拦截' }}</span>
              </div>
            </div>
            <div class="baseInfoContentItem specialItem">
              <div class="specialOne">
                <span class="span1">过驳费：</span>
                <span>{{ detailData.isExchange == 1 ? '拦截' : '不拦截' }}</span>
              </div>
              <div class="specialOne">
                <span class="span1">转船费：</span>
                <span>
                  {{
                    detailData.isExchangeShip === 1
                      ? '全部拦截'
                      : detailData.isExchangeShip === 2
                      ? '拦截一半'
                      : '全部不拦截'
                  }}
                </span>
              </div>
            </div>
          </div>
        </div>
        <div class="baseInfoTitle">
          <div class="line" />
          <span>适配车型</span>
        </div>
        <div class="baseInfoContent">
          <el-table
            :data="detailData.carModelList"
            style="width: 100%"
            border
            :header-cell-style="{
                  color: '#3B3B3B',
                  'font-size': '13px',
                  height: '35px',
                  background: '#E8E8E8',
                }"
            :cell-style="{ color: '#7F7F7F', 'font-size': '13px' }"
            ref="carTableRef">
            <el-table-column type="index" label="序号" width="50" align="center"></el-table-column>
            <el-table-column label="品牌" prop="brandName" align="center" />
            <el-table-column label="型号" prop="modelName" align="center" />
            <el-table-column label="状态" prop="status" align="center">
              <template slot-scope="scope">{{ scope.row.status | statusFormat }}</template>
            </el-table-column>
          </el-table>
        </div>
        <div class="operation">
          <div class="operationTitle">
            <div class="line" />
            <span>操作信息</span>
          </div>
          <div class="operationTable">
            <el-table
              :data="detailData.operateRecordList"
              border
              :header-cell-style="{
                color: '#3B3B3B',
                'font-size': '12px',
                height: '40px',
                background: '#E8E8E8',
              }">
              <el-table-column label="操作时间" align="center" width="160px">
                <div slot-scope="scope">{{ getTime(scope.row.createTime) }}</div>
              </el-table-column>
              <el-table-column prop="operateType" label="操作类型" align="center" />
              <el-table-column prop="operationName" label="操作人" align="center" />
              <el-table-column prop="remark" label="备注" align="center" />
            </el-table>
          </div>
        </div>
      </div>
    </el-dialog>
    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      width="650px"
      center
      @close="dialogClose"
      :close-on-click-modal="false">
      <div class="depart">
        <el-form :model="companyData" label-width="85px" :rules="rules" ref="ruleForm">
          <div-border label="基础信息" divStyle="margin: 10px 0 10px">
            <el-row>
              <el-col v-if='editType === 0'>
                <el-form-item
                  label="供应商："
                  style="margin-top: 10px; margin-bottom: 10px"
                  prop="name">
                  <el-select
                    v-model="companyData.name"
                    filterable
                    size="mini"
                    style="width: 100%"
                    placeholder="请选择供应商"
                    value-key="id"
                  @change="getContract">
                    <el-option
                      v-for="item in nameOption"
                      :key="item.id"
                      :label="item.name"
                      :value="item" />
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col v-if='editType === 0'>
                <el-form-item label="线路选择：" style="margin-bottom: 10px" prop="line">
                  <el-select
                    v-model="companyData.line"
                    @change="lineChange"
                    filterable
                    style="width: 100%"
                    size="small"
                    placeholder="请选择线路"
                    value-key="id">
                    <el-option
                      v-for="item in lineOption"
                      :key="item.id"
                      :label="item.line_name"
                      :value="item"></el-option>
                  </el-select>
                  <div v-if="lineData.line_name && lineData.line_name != ''">
                    <el-row
                      style="
                        color: rgb(153, 153, 153);
                        font-size: 12px;
                        line-height: 18px;
                        margin-bottom: 3px;
                      ">
                      <el-col v-if="!lineData.departure_port_id" :span="24"
                        >起始地：{{ lineData.start_address_name }}
                      </el-col>
                      <el-col v-else :span="24"
                        >起始地：{{ lineData.start_address_name }}【{{ lineData.departure_port }}】
                      </el-col>
                    </el-row>
                    <el-row style="color: rgb(153, 153, 153); font-size: 12px; line-height: 18px">
                      <el-col v-if="!lineData.arrive_port_id" :span="24">
                        终止地：{{ lineData.end_address_name }}
                      </el-col>
                      <el-col v-else :span="24"
                        >终止地：{{ lineData.end_address_name }}【{{ lineData.arrive_port }}】
                      </el-col>
                    </el-row>
                  </div>
                </el-form-item>
              </el-col>
              <el-col :span="12" v-if='editType === 0'>
                <el-form-item label="有效期始：" prop="start" style="margin-bottom: 20px">
                  <el-date-picker
                    v-model="companyData.start"
                    size="mini"
                    type="datetime"
                    style="width: 100%"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    placeholder="请选择有效开始时间" />
                </el-form-item>
              </el-col>
              <el-col :span="12" v-if='editType === 0'>
                <el-form-item label="结束日期：" prop="end">
                  <el-date-picker
                    v-model="companyData.end"
                    size="mini"
                    type="datetime"
                    style="width: 100%"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    placeholder="请选择有效结束时间"
                    default-time="23:59:59"/>
                </el-form-item>
              </el-col>
              <el-col>
                <el-form-item label='适配车型：' prop='model'>
                  <cascader ref='cascader' :options='modelOption' :props='props'
                            :filed='"model"' size="mini"
                            @getValue='getValue' />
                </el-form-item>
              </el-col>
            </el-row>
          </div-border>
          <div-border label="合同设置" divStyle="margin-top: 10px" v-if='editType === 0'>
            <el-row>
              <el-col :span='24'>
                <el-form-item label='合同：' prop='contract' style="margin-top: 15px">
                  <el-select v-model="companyData.contract" filterable style="width: 100%" size="small"
                             placeholder="请选择合同" value-key="id" @change="getContracts">
                    <el-option
                      v-for="item in contractOption" :key="item.id" :label="item.name"
                      :value="item"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
<!--            <el-row>-->
<!--              <el-col :span="24">-->
<!--                <el-form-item label="合同设置：">-->
<!--                  <el-row>-->
<!--                    <el-col :span="12">-->
<!--                      <span class="set-up" @click="contractBtn">设置</span>-->
<!--                    </el-col>-->
<!--                  </el-row>-->
<!--                  <el-row v-if="companyData.companyName || companyData.codeNumber">-->
<!--                    <el-col :span="24">-->
<!--                      <span class="item-span">合同名称：{{ companyData.companyName }}</span>-->
<!--                    </el-col>-->
<!--                    <el-col :span="15">-->
<!--                      <span class="item-span">合同编号：{{ companyData.codeNumber }}</span>-->
<!--                    </el-col>-->
<!--                  </el-row>-->
<!--                </el-form-item>-->
<!--              </el-col>-->
<!--            </el-row>-->
          </div-border>
          <div-border label="费用设置" divStyle="padding:10px 10px 10px" v-if='editType === 0'>
            <el-row>
              <el-col>
                <el-form-item
                  label="装车费："
                  prop="isLoad"
                  style="margin-bottom: 3px; padding-right: 20px">
                  <el-radio-group v-model="companyData.isLoad">
                    <el-radio size="mini" :label="0">不拦截</el-radio>
                    <el-radio size="mini" :label="1">拦截</el-radio>
                  </el-radio-group>
                </el-form-item>
              </el-col>
              <el-col>
                <el-form-item
                  label="卸车费："
                  prop="isUnload"
                  style="margin-bottom: 3px; padding-right: 20px">
                  <el-radio-group v-model="companyData.isUnload">
                    <el-radio size="mini" :label="0">不拦截</el-radio>
                    <el-radio size="mini" :label="1">拦截</el-radio>
                  </el-radio-group>
                </el-form-item>
              </el-col>
              <el-col>
                <el-form-item
                  label="过驳费："
                  prop="refute"
                  style="margin-bottom: 3px; padding-right: 20px">
                  <el-radio-group v-model="companyData.refute">
                    <el-radio size="mini" :label="0">不拦截</el-radio>
                    <el-radio size="mini" :label="1">拦截</el-radio>
                  </el-radio-group>
                </el-form-item>
              </el-col>
              <el-col>
                <el-form-item
                  label="转船费："
                  prop="refute"
                  style="margin-bottom: 3px; padding-right: 20px">
                  <el-radio-group v-model="companyData.isExchangeShip">
                    <el-radio size="mini" :label="0">全部不拦截</el-radio>
                    <el-radio size="mini" :label="1">全部拦截</el-radio>
                    <el-radio size="mini" :label="2">拦截一半</el-radio>
                  </el-radio-group>
                </el-form-item>
              </el-col>
            </el-row>
          </div-border>
          <div class="btnContainer">
            <el-button size="medium" class="searchBtn" :loading="addLoad" @click="addClick"
              >确定
            </el-button>
            <el-button size="medium" class="resetBtn" @click="dialogClose">关闭</el-button>
          </div>
        </el-form>
      </div>
    </el-dialog>
    <el-dialog
      :title="dialogContratTitle"
      :visible.sync="addVisible"
      :close-on-click-modal="false"
      append-to-body
      width="910px">
      <div class="navContract">
        <div class="navContainer">
          <p>合同编号：</p>
          <el-input
            v-model="addData.codeNumber"
            size="mini"
            style="width: 150px"
            placeholder="请输入合同编号" />
        </div>
        <div class="navContainer">
          <p>合同名称：</p>
          <el-input
            v-model="addData.contractName"
            size="mini"
            style="width: 150px"
            placeholder="请输入合同名称" />
        </div>
        <div class="navContainer">
          <p>签约单位：</p>
          <el-input
            v-model="addData.companyName"
            size="mini"
            style="width: 150px"
            placeholder="请输入签约单位" />
        </div>
        <div class="navBtn">
          <el-button size="small" class="searchBtn" @click="_contractPageList">查询</el-button>
          <el-button size="small" class="resetBtn" @click="resetContractBtn = false"
            >重置</el-button
          >
          <el-button size="small" class="searchBtn" @click="contractConfirm">确定</el-button>
        </div>
      </div>
      <el-table
        :data="contractData"
        highlight-current-row
        border
        ref="contractTable"
        @current-change="contractChange"
        v-loading="contractLoad"
        :header-cell-style="{
          color: '#3B3B3B',
          'font-weight': '700',
          padding: '0px',
          'font-size': '13px',
          height: '35px',
          background: '#E8E8E8',
        }"
        :cell-style="{ color: '#7F7F7F', 'font-size': '13px' }">
        <el-table-column type="index" width="50" />
        <el-table-column property="codeNumber" label="合同编号" min-width="150" align="center" />
        <el-table-column property="contractName" label="合同名称" min-width="150" align="center" />
        <el-table-column property="typeName" label="合同类型" min-width="100" align="center" />
        <el-table-column property="companyName" label="签约单位" min-width="150" align="center" />
        <el-table-column
          property="startDate"
          label="开始日期"
          min-width="100"
          :formatter="getDate"
          align="center" />
        <el-table-column
          property="endDate"
          label="结束日期"
          min-width="100"
          :formatter="getDate"
          align="center" />
      </el-table>
      <div style="margin-top: 20px">
        <el-pagination
          background
          :page-sizes="[10, 20, 30, 40]"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          @size-change="addContractSizeChange"
          @current-change="addContractCurrentChange"
          :current-page.sync="page"
          :page-size="rows" />
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import steps from '@/components/steps';
  import { formatDateTime, getSessionStore } from '@/config/mUtils';
  import divBorder from '@/components/divBorder';
  import { publicSelectLine, supplierPublicSelectPort } from '@/service/vehiclelog';
  import {
    portWorkList,
    portWorkAdd,
    highwayLineSelectWaterSupplier,
    portWorkDelete,
    portWorkRevise,
    portWorkDetail,
    portWorkEnable,
    contractPageList,
    getContractInfo,
    getContractPageList,
    addContract,
    deleteContractInfo, getCarSerieList,
  } from '@/service/financial';
  import { baseUrl } from '@/config/env';
  import cascader from '@/components/cascader';
  import { getImport, getImportUrl } from '@/service/getIP';
  export default {
    components: {
      steps,
      divBorder,
      cascader
    },
    data() {
      return {
        // 查询条件
        queryParams: {
          supplierName: '',
          status: '',
          departurePort: '',
          arrivePort: '',
          createByName: '',
          customerCarName: '',
          rows: 10,
          page: 1,
        },
        rows: 10,
        defaultQueryParams: {},
        // 状态
        stateOption: [
          {
            value: '',
            label: '全部',
          },
          {
            value: 0,
            label: '待生效',
          },
          {
            value: 1,
            label: '生效中',
          },
          {
            value: 2,
            label: '已失效',
          },
        ],
        tableLoad: false,
        TableData: [],
        detailDialogVisible: false, // 详情弹窗显隐
        detailData: {}, // 详情数据
        dialogVisible: false, // 新增/修改弹窗显隐
        dialogTitle: '', // 新增/修改弹窗标题
        addLoad: false, // 新增/修改确认加载状态
        nameOption: [], // 供应商
        portOption: [], // 港口
        modelOption: [],
        companyData: {
          // 新增/修改弹窗页面数据
          name: {
            id: '',
            name: '',
          },
          model: '',  // 适配车型
          contract: '',
          companyId: '', // 合同id
          companyName: '', // 合同名称
          codeNumber: '', // 合同编号
        },
        modelMap: new Map(),
        brandMap: new Map(),
        contractOption: [],
        props: {
          value: 'id',
          label: 'model',
          children: 'carModel',
          multiple: true,
        },
        // 表单验证
        rules: {
          name: [
            {
              required: true,
              message: '请选择供应商',
              trigger: 'change',
            },
          ],
          contract:[
            {
              required: true,
              message: '请选择合同',
              trigger: 'change',
            },
          ],
          line: [
            {
              required: true,
              message: '请选择线路',
              trigger: 'change',
            },
          ],
          start: [
            {
              required: true,
              message: '请选择有效开始时间',
              trigger: 'change',
            },
          ],
          end: [
            {
              required: true,
              message: '请选择有效结束时间',
              trigger: 'change',
            },
          ],
          model: {
            required: true,
            message: '请选择车型',
            trigger: 'blur',
          },
          isLoad: [
            {
              required: true,
              message: '请选择装车费',
              trigger: 'change',
            },
          ],
          isUnload: [
            {
              required: true,
              message: '请选择卸车费',
              trigger: 'change',
            },
          ],
          refute: [
            {
              required: true,
              message: '选择过驳费',
              trigger: 'change',
            },
          ],
        },
        lineData: {},
        lineOption: [],
        checkTableData: [],

        importLoading: false,
        uploadUrl: '', //导入地址
        uploadData: { mFile: '' },
        dialogContratTitle: '合同设置',
        addVisible: false,
        addData: {},
        contractVisible: false,
        condition: {},
        contractTableData: [],
        contractData: [],
        contractLoad: false,
        //总数据条数
        total: 0,
        //当前页数
        page: 1,
        //每页显示多少条数据
        row: 10,
        radioId: '',
        selectContract: {
          codeNumber: '',
          companyName: '',
          startDate: '',
          endDate: '',
        },
        editType:0
      };
    },
    filters: {
      getCreatTime(val) {
        if (val) {
          return formatDateTime(val, 'yyyy-mm-dd hh:ii:ss');
        } else {
          return '';
        }
      },
      statusFormat(value) {
        switch (value) {
          case 0:
            return '待生效';
          case 1:
            return '生效中';
          case 2:
            return '已失效';
        }
      },
    },
    computed: {
      stepState() {
        return function (state) {
          switch (state) {
            case '':
              return 'wait';
            case 'success':
              return 'success';
            case 'failure':
              return 'error';
          }
        };
      },
      getState() {
        return function (state) {
          switch (state) {
            case 0:
              return '待生效';
            case 1:
              return '生效中';
            case 2:
              return '已失效';
          }
        };
      },
      getTime() {
        return function (time) {
          return formatDateTime(time, 'yyyy-mm-dd hh:ii:ss');
        };
      },
    },
    async mounted() {
      //await this._portWorkList();
      this.defaultQueryParams = JSON.parse(JSON.stringify(this.queryParams));
      this.uploadUrl = getImportUrl('/price/portIntercept/batchImport');
    },
    methods: {
      getContract(){
        this.companyData.contract = ''
        this._contractPageList()
      },
      getContracts(){
        this.$forceUpdate()
      },
      // 合同设置 —— 分页查询
      async _contractPageList() {
        let obj = {
          // ...this.addData,
          // page: this.page,
          // rows: this.rows,
          id: this.companyData.name.id,
        };
        this.contractLoad = true;
        let res = await contractPageList(obj);
        this.contractLoad = false;
        if (res.status !== 0) return this.$message.error(res.message);
        this.contractOption = res.data;
        // this.total = res.data.total || 0;
        // if (this.companyData.companyId && this.addData.length > 0) {
        //   this.addData.forEach(item => {
        //     if (item.id === this.companyData.companyId) {
        //       this.$refs.contractTable.setCurrentRow(item);
        //     }
        //   });
        // }
      },
      //合同设置-重置
      resetContractBtn() {
        for (let key in this.addData) {
          this.addData[key] = '';
        }
      },
      contractBtn() {
        if (!this.companyData.name || this.companyData.name === '') {
          return this.$message.error('请选择供应商！');
        }
        this.selectContract = '';
        this._contractPageList();
        this.addVisible = true;
      },
      // 合同设置 —— 确认
      contractConfirm() {
        if (!this.selectContract.id || this.selectContract.id === '') {
          return this.$message.warning('请选择合同！');
        }
        this.companyData.companyId = this.selectContract.id;
        this.companyData.codeNumber = this.selectContract.codeNumber;
        this.companyData.companyName = this.selectContract.contractName;
        if (this.selectContract.startDate)
          this.companyData.startTime = this.selectContract.startDate;
        if (this.selectContract.endDate) this.companyData.endTime = this.selectContract.endDate;
        this.addVisible = false;
      },
      addContractSizeChange(rows) {
        this.condition.row = rows;
        this.getContractPage();
      },
      addContractCurrentChange(page) {
        this.condition.page = page;
        this.getContractPage();
      },
      // 合同编号 —— 选中数据
      contractChange(val) {
        this.selectContract = val;
      },
      // 时间长度处理
      getDate(row, column, cellValue) {
        if (cellValue) {
          return cellValue.substring(0, 10);
        } else {
          return '';
        }
      },
      async batchEnable() {
        if (this.checkTableData === null || this.checkTableData.length === 0)
          return this.$message.warning('请选择数据后启用！');
        this.$confirm('确认启用当前选中港口作业单价设置吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(async () => {
            const params = [];
            this.checkTableData.forEach(item => {
              params.push(item.id);
            });
            let res = await portWorkEnable({
              id: params.join(','),
              status: 1,
            });
            if (res.status !== 0) return this.$message.error(res.message);
            this.$message.success(res.message);
            this.$refs.tableRef.clearSelection();
            this.checkTableData = [];
            await this._portWorkList();
          })
          .catch(() => {});
      },
      selectionChange(selectionRow) {
        this.checkTableData = selectionRow;
      },
      rowStyle({ row }) {
        return this.checkTableData.includes(row) ? { background: 'rgb(197 226 255)' } : {};
      },
      getRowKey(row) {
        return row.id;
      },
      // 分页查询
      async _portWorkList() {
        this.tableLoad = true;
        const res = await portWorkList(this.queryParams);
        this.tableLoad = false;
        if (res.status !== 0) return this.$message.error(res.message);
        this.TableData = res.data.records;
        this.total = res.data.total;
      },
      // 查询港口、供应商
      async _allList() {
        let res = await supplierPublicSelectPort();
        if (res.status !== 0) return this.$message.error(res.message);
        this.portOption = res.data.map(item => {
          return item;
        });
        let res1 = await highwayLineSelectWaterSupplier();
        if (res1.status !== 0) return this.$message.error(res1.message);
        this.nameOption = res1.data;

        let res2 = await publicSelectLine({ type: 2 });
        if (res2.status !== 0) return this.$message.error(res2.message);
        this.lineOption = res2.data;
      },
      // 品牌/型号
      async _getCarSerieList() {
        let res = await getCarSerieList();
        if (res.status !== 0) return this.$message.error(res.message);
        this.modelOption = res.data.filter(item => {
          return item.carModel.length != 0;
        });
        this.modelOption = this.modelOption.map(item => {
          item.carModel.forEach((item, index) => {
            this.modelMap.set(item.id, item.model);
            this.brandMap.set(item.brand_id, item.brand_name);
          });
          return {
            ...item,
            model: item.brand,

          };
        });
        // console.log(this.modelOption)
        this.modelOption.unshift({
          model: '全选',
          id: '全选',
        });
      },
      getValue(filed, data, isAll) {
        let subData = JSON.parse(JSON.stringify(data));
        isAll ? subData.shift() : '';
        this.companyData[filed] = subData;
      },
      // 数据大小
      contractSizeChange(sizes) {
        this.queryParams.rows = sizes;
        this._portWorkList();
      },
      // 翻页
      contractCurrentChange(page) {
        this.queryParams.page = page;
        this._portWorkList();
      },
      // 时间判断
      bjDate(date, date1) {
        var date = new Date(date);
        var date1 = new Date(date1);
        return date.getTime() - date1.getTime() < 0;
      },
      // 新增/修改 —— 取消
      dialogClose() {
        this.$refs.ruleForm.resetFields()
        this.$refs.cascader.value = []
        this.dialogVisible = false
      },
      // 新增/修改 —— 确认
      addClick() {
        this.$refs.ruleForm.validate(async valid => {
          if (valid) {
            if (!this.bjDate(this.companyData.start, this.companyData.end))
              return this.$message.warning('结束时间不得小于开始时间！');
            if (
              this.companyData.isLoad == 0 &&
              this.companyData.isUnload == 0 &&
              this.companyData.refute == 0 &&
              this.companyData.isExchangeShip == 0
            ) {
              return this.$message.warning('装车费、卸车费、过驳费、转船费至少要有一个！');
            }
            let {
              model,
            } = this.companyData;
            const obj = {
              status: this.companyData.status,
              contractId: this.companyData.contract.id,
              supplierId: this.companyData.name.id,
              startDate: this.companyData.start,
              endDate: this.companyData.end,
              lineId: this.companyData.line.id,
              // 装车费
              isLoading: this.companyData.isLoad,
              // 卸车费
              isUnload: this.companyData.isUnload,
              // 过驳费
              isExchange: this.companyData.refute,
              // 转船费
              isExchangeShip: this.companyData.isExchangeShip,
              carModelList: model.map((item) => {
                return {
                  modelId: item[1],
                  modelName: this.modelMap.get(item[1]),
                  brandId: item[0],
                  brandName: this.brandMap.get(item[0]),
                };
              }),
            };
            if (this.dialogTitle != '添加港口作业费拦截') {
              obj.id = this.companyData.id;
              obj.supplierName = this.companyData.name.short_name;
              obj.lineName = this.companyData.line.line_name;
            }
            this.addLoad = true;
            // return false
            const res =
              this.dialogTitle == '添加港口作业费拦截'
                ? await portWorkAdd(obj)
                : await portWorkRevise(obj);
            this.addLoad = false;
            if (res.status !== 0) return this.$message.error(res.message);
            this.$message.success(res.message);
            this.dialogClose();
            await this._portWorkList();
          } else {
            return false;
          }
        });
      },
      // 删除
      deleteClick(id) {
        this.$confirm('确认删除当前港口作业单价设置吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(async () => {
            let res = await portWorkDelete(id);
            if (res.status !== 0) return this.$message.error(res.message);
            this.$message.success(res.message);
            await this._portWorkList();
          })
          .catch(() => {});
      },
      onClickDeletes() {
        if (this.checkTableData.length > 0) {
          this.$confirm('确认删除当前港口作业单价设置吗？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
          })
            .then(async () => {
              this.tableLoad = true;
              let ids = '';
              this.checkTableData.forEach(rowData => {
                ids = ids + rowData['id'] + ',';
              });
              ids = ids.substring(0, ids.lastIndexOf(','));
              let res = await portWorkDelete(ids);
              if (res.status !== 0) {
                this.$message.error(res.message);
                this.tableLoad = false;
                return;
              }
              this.$message.success(res.message);
              this.$refs.tableRef.clearSelection();
              this.checkTableData = [];
              await this._portWorkList();
            })
            .catch(() => {});
        } else {
          this.$message({
            message: '请先选择数据！',
            type: 'warning',
          });
        }
      },
      // 启用
      enableClick(row) {
        this.$confirm('确认启用当前港口作业单价设置吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(async () => {
            let obj = {
              id: row.id,
              status: 1,
            };
            let res = await portWorkEnable(obj);
            if (res.status !== 0) return this.$message.error(res.message);
            this.$message.success(res.message);
            await this._portWorkList();
          })
          .catch(() => {});
      },
      // 线路改变
      lineChange(val) {
        this.lineData = val;
      },
      // 停用
      disableClick(row) {
        this.$confirm('确认停用当前港口作业单价设置吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(async () => {
            let obj = {
              id: row.id,
              status: 2,
            };
            let res = await portWorkEnable(obj);
            if (res.status !== 0) return this.$message.error(res.message);
            this.$message.success(res.message);
            await this._portWorkList();
          })
          .catch(() => {});
      },
      // 批量停用
      onClickStops() {
        if (this.checkTableData.length > 0) {
          this.$confirm('确认停用当前港口作业单价设置吗？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
          })
            .then(async () => {
              this.tableLoad = true;
              const ids = this.checkTableData.map(item => item.id).join(',');
              let res = await portWorkEnable({
                id: ids,
                status: 2,
              });
              if (res.status !== 0) {
                this.$message.error(res.message);
                this.tableLoad = false;
                return;
              }
              this.$message.success(res.message);
              this.$refs.tableRef.clearSelection();
              this.checkTableData = [];
              await this._portWorkList();
            })
            .catch(() => {});
        } else {
          this.$message({
            message: '请先选择要停用的港口作业单价设置！',
            type: 'warning',
          });
        }
      },
      // 详情
      async detailClick(id) {
        const res = await portWorkDetail(id);
        if (res.status !== 0) return this.$message.error(res.message);
        this.detailData = res.data;
        this.detailDialogVisible = true;
      },
      // 修改
      async changeClick(id,type) {
        this.editType = type
        await this._allList();
        await this._getCarSerieList()
        if(this.editType === 0){
          this.dialogTitle = '修改车型'
        }else {
          this.dialogTitle = '修改港口作业费拦截'
        }
        this.dialogVisible = true;
        const res = await portWorkDetail(id);
        if (res.status !== 0) return this.$message.error(res.message);
        let modelList = [];
        if (res.data.carModelList && res.data.carModelList.length > 0) {
          res.data.carModelList.forEach(item => {
            modelList.push([item.brandId, item.modelId]);
          });
        }
        this.$refs.cascader.value = modelList;
        let name = '';
        if (res.data.contractCode != null && res.data.contractCode !== '') {
          name = res.data.contractCode + '-' + res.data.contractName;
        } else {
          name = null;
        }
        this.companyData = {
          ...res.data,
          name: {
            id: res.data.supplierId,
            short_name: res.data.supplierName,
          },
          line: {
            id: res.data.lineId,
            line_name: res.data.lineName,
          },
          contract:{
            id: res.data.contractId,
            name:name
          },
          start: res.data.startDate,
          end: res.data.endDate,
          isLoad: res.data.isLoading,
          isUnload: res.data.isUnload,
          refute: res.data.isExchange,
          isExchangeShip: res.data.isExchangeShip,
          model: modelList,  // 适配车型
        };
      },
      // 查询
      searchBtn() {
        this.page = 1;
        this._portWorkList();
      },
      // 新增
      addBtn() {
        this.editType = 0;
        this.dialogTitle = '添加港口作业费拦截';
        this.companyData = {
          isLoad: 0,
          isUnload: 0,
          refute: 0,
          isExchangeShip: 0,
        };
        this.lineData = {};
        this.dialogVisible = true;
        this._allList();
        this._getCarSerieList()
      },
      // 重置
      resetBtn() {
        this.queryParams = JSON.parse(JSON.stringify(this.defaultQueryParams));
      },
      //导出数据
      exportData() {
        // let token = getSessionStore('token');
        const { supplierName, status, departurePort, arrivePort,customerCarName } = this.queryParams;
        // window.location.href = `${baseUrl}/platform/price/portIntercept/export?access_token=${token}&supplierName=${supplierName}&status=${status}&departurePort=${departurePort}&arrivePort=${arrivePort}&customerCarName=${customerCarName}`;
        window.exportExcelGet('/platform/price/portIntercept/export', `supplierName=${supplierName}&status=${status}&departurePort=${departurePort}&arrivePort=${arrivePort}&customerCarName=${customerCarName}`)
      },
      //模板下载
      download() {
        window.location.href = '/file/供应商港口装卸费拦截导入模板.xls';
      },
      // 批量导入
      planOnSuccess(res) {
        this.importLoading = false;
        this.$alert(res.message, '提示', {
          confirmButtonText: '关闭',
          callback: async () => {
            this.TableData = res.data;
            await this._portWorkList();
          },
        });
      },
      beforeUpload(file) {
        let len = file.name.split('.').length;
        if (file.name.split('.')[len - 1] == 'xls' || file.name.split('.')[len - 1] == 'xlsx') {
          this.uploadData.mFile = file.name;
          this.importLoading = true;
        } else {
          this.$message.error('请选择excel文件导入！！！');
          return false;
        }
      },
    },
  };
</script>

<style lang="scss" scoped>
  .mainContainer {
    width: 100%;
    padding: 20px 15px 0 25px;

    .line {
      width: 12px;
      height: 32px;
      background-color: rgba(51, 84, 131, 100);
      margin-right: 10px;
    }

    .line + span {
      font-size: 16px;
      color: rgba(51, 84, 131, 100);
      font-weight: 600;
    }
    .set-up {
      color: #3187ff;
      position: absolute;
      padding-right: 10px;
      height: 24px;
      line-height: 24px;
      right: 10px;
      top: calc(50% - 12px);
      text-decoration: underline;
      cursor: pointer;
    }

    .nav {
      width: 100%;
      display: flex;
      align-items: center;
      flex-wrap: wrap;

      &Container {
        width: 200px;
        display: flex;
        align-items: center;
        margin-right: 5px;
        margin-bottom: 5px;

        p {
          font-size: 14px;
          color: rgba(16, 16, 16, 100);
        }
      }

      &Btn {
        display: flex;
        align-items: center;
        margin-bottom: 5px;
      }

      ::v-deep {
        label.el-form-item__label {
          font-weight: 500;
          color: #101010;
        }
      }
    }

    .content {
      display: flex;
      flex-direction: column;
      align-items: center;

      .tableContainer {
        margin-bottom: 25px;
        width: 100%;

        ::v-deep {
          .el-badge__content {
            top: 4px !important;
            right: 1px !important;
          }

          .el-badge__content {
            background-color: #f56c6c !important;
          }

          .el-table .cell {
            padding: 0;
          }

          .el-table th {
            padding: 0;
          }

          .el-table td {
            padding: 0;
          }
        }
      }

      .paginationContainer {
        margin-right: auto;
        display: flex;
        align-items: center;
        margin-bottom: 20px;

        span {
          font-size: 13px;
        }
      }
    }

    .detail {
      width: 100%;
      padding: 10px 0 20px 20px;
      max-height: 70vh;
      overflow: auto;

      .baseInfo {
        display: flex;
        flex-direction: column;

        &Title {
          display: flex;
          align-items: flex-end;

          p {
            font-weight: 700;
            font-size: 14px;
            color: rgba(51, 136, 255, 1);
            margin-left: 10px;
          }
        }

        &Content {
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          padding: 20px 23px 0 23px;

          .addressItem {
            font-size: 12px;
            color: rgba(153, 153, 153, 1);
            margin-bottom: 10px;
            margin-left: 70px;
          }

          &Item {
            margin-bottom: 20px;

            .imgContainer {
              display: flex;
              align-items: center;
            }

            .span1 {
              font-weight: 700;
            }

            span {
              font-size: 14px;
            }

            .specialOne {
              width: 50%;
            }
          }

          .specialItem {
            display: flex;
          }
        }
      }

      .operation {
        display: flex;
        flex-direction: column;

        ::v-deep {
          .el-table td,
          .el-table th {
            padding: 0;
          }

          .cell {
            font-size: 10px;
            padding: 0;
          }
        }

        &Title {
          display: flex;
          align-items: flex-end;

          p {
            font-weight: 700;
            font-size: 14px;
            color: rgba(51, 136, 255, 1);
            margin-left: 10px;
          }
        }

        &Table {
          width: 100%;
          margin-top: 10px;
          padding: 0 20px;
        }
      }
    }

    .reasonContainer {
      width: 100%;
      padding: 20px 30px;

      ::v-deep {
        .el-textarea__inner {
          min-height: 100px !important;
        }
      }

      .reasonBtn {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: flex-end;
      }
    }

    .carContainer {
      width: 100%;
      padding: 15px 40px 10px 20px;
      max-height: 75vh;
      overflow: auto;

      &Title {
        display: flex;
        flex-direction: column;

        span {
          color: #101010;
          font-weight: 700;
          margin-bottom: 5px;
        }

        &Content {
          width: 100%;
          padding-left: 15px;
          display: flex;
          flex-wrap: wrap;
          align-items: center;
          margin-bottom: 10px;

          &Item {
            height: 25px;
            padding: 0 5px;
            background-color: #a4adb3;
            color: #fff;
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-right: 10px;
            margin-bottom: 5px;

            i {
              color: #000;
              font-size: 17px;
              cursor: pointer;
            }

            p {
              cursor: pointer;
            }
          }
        }
      }

      .btnContainer {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        margin: 30px 0 10px 0;

        button {
          margin: 0 15px;
        }
      }
    }

    .depart {
      width: 100%;
      padding: 10px 40px 10px 10px;
      max-height: 75vh;
      overflow: auto;

      .specialItem {
        ::v-deep {
          .el-form-item__content {
            margin-left: 0 !important;
          }
        }
      }

      ::v-deep {
        .el-form-item__label {
          font-weight: 700;
        }

        .el-form-item {
          margin-bottom: 13px;
        }

        .el-form-item__label {
          padding: 0;
        }

        .el-form-item__content {
          position: relative;
        }
      }

      .btnContainer {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        margin: 30px 0 10px 0;

        button {
          margin: 0 15px;
        }
      }
    }

    ::v-deep {
      .el-table th > .cell {
        font-weight: 700 !important;
      }
    }
  }

  ::v-deep {
    .el-form-item.specialItem {
      margin-bottom: 0px !important;
    }

    .el-dialog__header {
      padding: 9px 20px 9px;
      background: #335483;
    }

    .el-dialog__title {
      line-height: 24px;
      font-size: 14px;
      color: #ffffff;
    }

    .el-dialog__headerbtn {
      top: 9px;
    }

    .el-dialog__headerbtn .el-dialog__close {
      color: #fff;
      font-size: 25px;
    }

    .el-dialog__body {
      padding: 0;
    }

    .el-form-item__error {
      margin-top: -3px;
      padding-top: 0px;
    }
  }
  .navContainer {
    display: inline-block;
    width: 230px;
    text-align: center;

    p {
      display: inline-block;
      width: 70px;
    }
  }
  ::v-deep {
    .el-table th.require > div::before {
      content: '*';
      color: red;
    }

    .el-input.is-disabled .el-input__inner {
      background-color: #fff;
      cursor: pointer;
    }

    .el-table__body tr.current-row > td {
      background-color: #409eff;
      color: #fff !important;
    }

    .cell .el-form-item {
      padding: 0 2px;
    }

    .el-dialog__header {
      padding: 9px 20px 9px;
      background: #335483;
      text-align: center;
    }

    .el-dialog__headerbtn {
      top: 0px;
      height: 42px;
      line-height: 42px;
      right: 10px;
      font-size: 20px;

      .el-dialog__close {
        color: #fff;
        font-size: 25px;
      }
    }

    .el-dialog__title {
      color: #fff;
      font-weight: 700;
      font-size: 16px;
      line-height: 24px;
    }

    .el-dialog__body {
      padding: 20px !important;
      max-height: 60vh;
      overflow-y: auto;
    }

    .el-pagination {
      text-align: left !important;
    }

    .el-dialog__footer {
      text-align: right !important;
    }

    .el-form-item__content {
      line-height: 40px;
    }

    .cell .el-radio {
      margin-right: 0px;
      float: left;
      left: 10px;
    }

    .el-radio:last-child {
      margin-top: 3px;
    }
  }
</style>
